<template>
  <nav v-if="last > 1" class="border-t border-gray-200  flex items-center justify-between px-0">
    <div class="-mt-px w-0 flex-1 flex">
      <button type="button" :disabled="currPage === 1" @click="handleChange(currPage -1)"
              class="border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">
        <ArrowNarrowLeftIcon class="mr-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
        Назад
      </button>
    </div>
    <span
        class="md:hidden border-transparent text-gray-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium">
        {{ currPage }} / {{ last }}
      </span>
    <div class="hidden md:-mt-px md:flex">
      <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->

      <template v-for="(page, i) in pages">
        <span :key="`pag_yes_${page}`" v-if="page === '...' "
              class="border-transparent text-gray-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium">
        ...
      </span>
        <button type="button" :key="`pag_no_${i}`" v-else @click="handleChange(page)"
                :class="[page === currPage ? 'border-primary-500 text-primary-600' : 'text-gray-500 ']"
                class="border-transparent hover:text-gray-700 hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium">
          {{ page }}
        </button>
      </template>

    </div>
    <div class="-mt-px w-0 flex-1 flex justify-end">
      <button type="button" :disabled="currPage === last" @click="handleChange(currPage  + 1)"
              class="border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">
        Вперед
        <ArrowNarrowRightIcon class="ml-3 h-5 w-5 text-gray-400" aria-hidden="true"/>
      </button>
    </div>
  </nav>
</template>

<script>

import {useRoute, useRouter} from 'vue-router'
import {ref} from 'vue'
import {ArrowNarrowLeftIcon, ArrowNarrowRightIcon} from '@heroicons/vue/solid'


export default {
  components: {
    ArrowNarrowLeftIcon,
    ArrowNarrowRightIcon,
  },

  setup(props, {emit}) {
    const route = useRoute()
    const router = useRouter()
    const currPage = ref(props['current'])
    const queryKey = ref(props['query_param'])
    const isQuery = queryKey.value.length > 0

    if (isQuery && !(queryKey.value in route.query)) {
      router.push({path: route.path, query: {[queryKey.value]: 1}})
      currPage.value = 1
    } else {
      currPage.value = route.query[queryKey.value]
    }

    //console.log('change', currPage.value)
    emit('change', currPage.value)

    return {
      currPage, isQuery, queryKey
    }

  },

  emits: ['change'],
  props: {
    query_param: {
      type: String,
      default: ''
    },
    current: {
      required: true
    },
    last: {
      required: true
    },
    from: {
      required: true
    },
    to: {
      required: true
    },
    total: {
      required: false
    }

  },
  data() {
    return {
      maxPages: 6,
      leftPages: [],
      pages: 0,
    }
  },
  methods: {

    getRange(start, end) {
      return Array(end - start + 1)
          .fill()
          .map(function (v, i) {
            return i + start;
          });
    },
    pagination() {

      const currentPage = this.currPage
      const pageCount = this.last
      let delta;
      if (pageCount <= 7) {
        // delta === 7: [1 2 3 4 5 6 7]
        delta = 7;
      } else {
        // delta === 2: [1 ... 4 5 6 ... 10]
        // delta === 4: [1 2 3 4 5 ... 10]
        delta = currentPage > 4 && currentPage < pageCount - 3 ? 2 : 4;
      }
      let range = {
        start: Math.round(currentPage - delta / 2),
        end: Math.round(currentPage + delta / 2)
      };
      if (range.start - 1 === 1 || range.end + 1 === pageCount) {
        range.start += 1;
        range.end += 1;
      }
      let pages = currentPage > delta
          ? this.getRange(Math.min(range.start, pageCount - delta), Math.min(range.end, pageCount))
          : this.getRange(1, Math.min(pageCount, delta + 1));
      let withDots = function (value, pair) {
        return (pages.length + 1 !== pageCount ? pair : [value]);
      };
      if (pages[0] !== 1) {
        pages = withDots(1, [1, '...']).concat(pages);
      }
      if (pages[pages.length - 1] < pageCount) {
        pages = pages.concat(withDots(pageCount, ['...', pageCount]));
      }
      //console.log('generate paginate', pages)
      return pages;

    },


    handleChange(page) {
      if (this.isQuery) {
        this.$router.push({path: this.$route.path, query: {[this.queryKey]: page}})
      }
      //console.log('update change', page)
      this.$emit('change', page)
    },
  },
  watch: {
    current(val) {
      //console.log('update paginate, page: ', val)
      this.currPage = val;
      this.pages = this.pagination()
    },
    total() {
      this.pages = this.pagination()
    }
  },
  mounted() {

  },
}
</script>